// extracted by mini-css-extract-plugin
module.exports = {"container":"duplicateOIB_container__3o5fr","title":"duplicateOIB_title__1tGq3","content":"duplicateOIB_content__2o6xX"};